<template lang="pug">
    .animation(ref='animation')
        .lattice
            .timber.timber_hor-1(ref='timbers')
            //.timber.timber_hor-2
            .timber.timber_vert-1
            //.timber.timber_vert-2
        //-svg(width='331' height='331' viewbox='0 0 331 331' fill='none')
            path(d='M0 78.7814L0 108.791L331 108.791V78.7814L0 78.7814Z' fill='black')
            path(d='M0.00195313 211.182L0.00195312 241.191L331.002 241.191V211.182L0.00195313 211.182Z' fill='black')
            g(ref='timbers')
                path(d='M84.2931 331H114.303L114.303 3.05176e-05H84.2931L84.2931 331Z' fill='black')
                path(d='M216.695 331H246.705L246.705 3.05176e-05H216.695L216.695 331Z' fill='black')


</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';
export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'middle-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(this.$refs.timbers, {x: '200%'}, {duration: 3, x: '0'}, 0);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    position: relative;
    @media screen and (--viewport-mobile-lp) {
        min-width: 80vh;
    }
}
.lattice {
    width: 100%;
}
.timber {
    &_vert {
        &-1 {
            padding-bottom: 100%;
            width: calc((100% + 120px) / 3);
            height: 100%;
            max-height: 100vh;
            position: relative;
            left: calc((100% - 60px) / 3);
            border-left: 1.875rem solid #000;
            border-right: 1.875rem solid #000;
        }
    }
    &_hor {
        &-1 {
            padding-left: 100%;
            height: calc((100% + 120px) / 3);
            width: 100%;
            max-width: 100vh;
            position: absolute;
            top: calc((100% - 60px) / 3);
            border-top: 1.875rem solid #000;
            border-bottom: 1.875rem solid #000;
        }
    }
}
</style>
